import React from 'react'

const Checkbox = (props: {
  label: string
  isChecked: boolean
  id: string
  onChange: (val: any) => void
  value: string
  registerField?: any
  fieldId?: string
  required?: boolean
  validate?: any
}) => {
  return (
    <div className="checkbox-wrapper">
      <input
        type="checkbox"
        className={'custom-input'}
        checked={props.isChecked}
        id={props.id}
        onChange={(e) => props.onChange(e)}
        value={props.value}
      />
      <label htmlFor={props.id}>{props.label}</label>
    </div>
  )
}
export default Checkbox
